import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import inskiVid from '../Assets/Videos/in-ski-short-promo.mp4';

function InSkiDownloadView() {
    return (
        <Container className="inski-card">
            <Row className="align-items-center">
                <Col md={7} className="mb-4 mb-md-0">
                    <div className="video-wrapper" style={{ borderRadius: '15px', overflow: 'hidden', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
                        <video autoPlay loop muted playsInline controls style={{ width: '100%', display: 'block' }}>
                            <source src={inskiVid} type='video/mp4' />
                        </video>
                    </div>
                </Col>
                <Col md={5}>
                    <div style={{ textAlign: 'left', paddingLeft: '20px' }}>
                        <h1 style={{ fontFamily: "Inter-SemiBold", marginBottom: '1rem' }}>InSki</h1>
                        <p style={{ fontFamily: "Inter-Regular", color: 'GrayText', marginBottom: '2rem' }}>
                            Plan trips, connect with friends, and track every run — all in one place.
                            <br /><br />
                            InSki makes it easy to experience the mountains like never before. Whether you’re chasing fresh powder, logging your best ski days, or meeting new people who share your love for the slopes, InSki brings the ski community together in one seamless app.
                        </p>

                        <a href="https://apps.apple.com/app/inski/id6751788455" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                            <button className='downloadButton'>
                                 Download on Apple
                            </button>
                        </a>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default InSkiDownloadView;
